import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';

class LoadingMass extends Component {

    render() {
        console.log("loading mass set");
        return (
            <div class="loader-overlay">
                <div class="loader-inner"></div>
                <div class="loader"></div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        notInHotelPopup: state.store.notInHotelPopup,
        popupMsg: state.store.popupMsg
    }
}

export default connect(
    mapStateToProps,
    null
)(LoadingMass);